import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'par-delete-favorite-product',
  templateUrl: './delete-favorite-product.component.html',
  styleUrls: ['./delete-favorite-product.component.scss']
})
export class DeleteFavoriteProductComponent implements OnInit {
  confirmMessage: string;
  header: string;
  confirmBtn: string;
  cancelBtn: string;

  constructor(
    public dialogRef: MatDialogRef<DeleteFavoriteProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.setData();
  }

  setData() {
    if (this.data.productDescription) {
      this.header = 'Confirm Removal';
      this.confirmBtn = 'Yes, remove this item';
      this.cancelBtn = 'No, return to Favorites';
    } else {
      this.header = 'Update Confirmation';
      this.confirmBtn = 'Delete this list';
      this.cancelBtn = 'Cancel';
    }
  }

  onClose() {
    this.dialogRef.close();
  }

}
